import React from "react";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import {
  ADMISSION_PLACEHOLDER_ITEMS,
  ADMISSION_ACCOUNT_SETUP_ITEM_KEYS,
} from "Admissions/features/AdminPortal/modules/AdmissionAccountSetupItems";

// POC 1 only — registers sibling routes of /admissions/unitsAndSchools for
// every placeholder item across the 3 sidebar sections (Account setup,
// Members, Other settings). Each renders the AccountSetupPlaceholder with
// the matching active sidebar key and localised title; clicking sidebar items
// navigates between siblings.
const makeRoute = ({ key, labelLocale }) => ({
  path: key,
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-account-setup-placeholder" */ "Admissions/features/AdminPortal/components/AccountSetupPlaceholder"
    ).then(({ default: AccountSetupPlaceholder }) => {
      const Wrapper = () => (
        <AccountSetupPlaceholder
          activeItemKey={key}
          labelLocale={labelLocale}
        />
      );
      Wrapper.displayName = `AdmissionAccountSetupPlaceholder(${key})`;
      return Wrapper;
    })
  ),
});

export const getAccountSetupPlaceholderRoutes = () =>
  ADMISSION_PLACEHOLDER_ITEMS.map(makeRoute);

export { ADMISSION_ACCOUNT_SETUP_ITEM_KEYS };
